<template>
    <div class="loading" v-if="loading">
       <div class="image">
          <img src="../assets/images/homeImages/loding.gif" alt="" srcset="">
       </div>
    </div>
</template>

<script>

export default {
  name: 'load',
  data () {
    return {
        loading: 0
    }
  },
  props:{
    footerIcon:{
      type: Number
    }
  },
  watch:{
    getLoading (val) {
      this.loading = val
    }
  },
  computed: {
    getLoading () {
      return this.$store.state.loading
    }
  },
  mounted () {
    this.loading = this.$store.getters.getLoading
  },
  methods:{
    getVlaue () {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.loading{
    // background-image: url('../assets/images/homeImages/loading.gif')
    height: 100%;
    width: 100%;
    background: #fff;
    z-index: 111111;
    position: fixed;
    top: 0;
    display: table;
}
.image {
    display: table-cell;
    vertical-align: middle;
}
img {
    width: 100%;
}
    
</style>



// WEBPACK FOOTER //
// src/components/loading.vue